<template>
  <v-select
    hide-details="auto"
    :items="status"
    v-model="filterDatas.type"
    item-text="name"
    item-value="id"
    label="Payment Form"
    outlined
    clearable
    dense
    @change="emitInput(filterDatas.type)"
  ></v-select>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    status: [
      {
        id: 'purchase',
        name: 'purchase',
      },
      {
        id: 'sale',
        name: 'sales',
      },
    ],
    selectStatus: null,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_PAYMENT_FORM_FILTER', data);

      this.$emit('input', this.filterDatas.type);
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectStatus = null;
      },
      deep: true,
    },
  },
  created() {
    this.$emit('input', this.filterDatas.type);
  },
};
</script>
